import { isEmpty } from "lodash";

export const areAllTemplateVariablesFilled = (
  variablesDetails: any[] = [],
  campaignRule: Record<string, any> | null
): boolean => {
  if (!variablesDetails?.length) return true;
  if (!campaignRule) return false;

  return variablesDetails.every(({ variable, type }) => {
    const value = campaignRule[variable];

    switch (type) {
      case "multiselect_dropdown":
        return Array.isArray(value) && value?.length > 0;

      case "dropdown":
      case "string":
        return typeof value === "string" && value.trim() !== "";

      case "number":
        return value !== null && value !== undefined && value !== "";

      default:
        return !isEmpty(value);
    }
  });
};
